import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export enum RouteMode {
  PRIVATE = 'PRIVATE',
  HYBRID = 'HYBRID'
}

type AppStoreType = {
  lastRouteMode: RouteMode | undefined
  setLastRouteMode: (lastRouteMode: RouteMode) => void
  firstAccessComplete: boolean
  setFirstAccessComplete: (firstAccessComplete: boolean) => void
  isPreview: boolean
}

const initialState = {
  lastRouteMode: undefined,
  firstAccessComplete: false,
  isPreview: false
}

export const useAppStore = create<AppStoreType>()(
  devtools((set) => ({
    ...initialState,
    setLastRouteMode: (lastRouteMode: RouteMode): void => set({ lastRouteMode }),
    setFirstAccessComplete: (firstAccessComplete: boolean): void => set({ firstAccessComplete })
  }))
)
